<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="商品名称：" prop="title">
                <span>{{model.title}}</span>
            </el-form-item>
            <el-form-item label="商品简介：" prop="ftitle">
                <span>{{model.ftitle}}</span>
            </el-form-item>
            <el-form-item label="品牌：" prop="brand">
                <span>{{model.brand}}</span>
            </el-form-item>
            <el-form-item label="所在分类：" prop="cat_name">
                <span>{{model.cat_name}}</span>
            </el-form-item>
            <el-form-item label="封面图片：" prop="imgpath" class="tipsitem">
                <el-upload
                    list-type="picture-card"
                    action="none"
                    :on-preview="handlePictureCardPreview"
                    :file-list="imgArr" :disabled="true">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" :modal="false">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
            <el-form-item label="图片介绍：" prop="imgpath" class="tipsitem">
                <el-upload
                    list-type="picture-card"
                    action="none"
                    :on-preview="handlePictureCardPreview"
                    :file-list="imgArr1" :disabled="true">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" :modal="false">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
            <el-form-item label="视频介绍：" prop="video" v-if="model.video">
                <span>{{model.video}}</span>
            </el-form-item>
            <el-form-item label="最低价格：" prop="price_min">
                <span>{{model.price_min}}</span>
            </el-form-item>
            <el-form-item label="最低原价：" prop="price_min_y">
                <span>{{model.price_min_y}}</span>
            </el-form-item>
            <el-form-item label="最高价格：" prop="price_max">
                <span>{{model.price_max}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="销量：" prop="sales">
                <span>{{model.sales}}</span>
            </el-form-item>
            <el-form-item label="首页标签：" prop="index_tag">
                <span>{{ transEnu(model.goods_tag, "goods_tag") }}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{ transEnu(model.state, "goods_state") }}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="addtime">
                <span>{{model.addtime}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'goodsInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                title: '',
                ftitle: '',
                cat_id: '',
                cat_name: '',
                spec: '',
                main_pic: '',
                images: '',
                gdesc: '',
                price_min: '',
                price_min_y: '',
                price_max: '',
                order_index: '',
                sales: '',
                state: '',
                goods_tag: '',
                addtime: '',
            },
            getObj:{
                url:'/api/admin/goods/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            imgArr: [],
            imgArr1: [],
            enu_name: ['goods_state', 'goods_tag'],
            dialogImageUrl: '',
            dialogVisible: false
        };
    },
    methods: {
        formateData() {
            this.imgArr = []
            this.imgArr1 = []
            if(this.$isNotNull(this.model.images)){
                let temp = JSON.parse(this.model.images)
                for (let i in temp) {
                    let tt = {name: temp[i],url: temp[i]}
                    this.imgArr.push(tt)
                }
            }
            if(this.$isNotNull(this.model.gdesc)){
                let temp = JSON.parse(this.model.gdesc)
                for (let i in temp) {
                    let tt = {name: temp[i],url: temp[i]}
                    this.imgArr1.push(tt)
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
    }
};
</script>